import React from "react";
import { Adsense } from "@ctrl/react-adsense";

function AdCard({ ad }) {
  if (!ad) return null;

  const isAdsense = ad.client && ad.slot;

  /* ==========================
     ✅ ADSENSE (LIBRARY HANDLES PUSH)
     ========================== */
  if (isAdsense) {
    return (
      <div
        className="card"
        style={{
          padding: "12px",
          minHeight: "250px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Adsense
          client="ca-pub-6409212221098617"
          slot="3259974102"
          style={{
            display: "inline-block",
            width: "300px",
            height: "300px",
          }}
          format=""
        />

        <div
          style={{
            fontSize: "10px",
            color: "#999",
            marginTop: "8px",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Advertisement
        </div>
      </div>
    );
  }

  /* ==========================
     ✅ IMAGE AD (FALLBACK)
     ========================== */
  const { image, link } = ad;

  return (
    <div
      className="card"
      onClick={() => link && window.open(link, "_blank", "noopener,noreferrer")}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "12px",
        minHeight: "250px",
        cursor: link ? "pointer" : "default",
      }}
    >
      <img
        src={image}
        alt="Advertisement"
        style={{
          maxWidth: "100%",
          height: "auto",
          objectFit: "contain",
        }}
      />

      <div
        style={{
          paddingTop: "15px",
          fontSize: "10px",
          color: "#999",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        Advertisement
      </div>
    </div>
  );
}

export default AdCard;
